module.exports = __webpack_public_path__ + "img/picture.28488618.svg";